export default {
  metaTitle: 'Settings',
  pageTitle: 'Settings',
  country: 'Country Site',
  placeholder1: 'Store Name',
  logo: 'Upload Store\'s LOGO',
  placeholder2: 'Select Division',
  placeholder3: 'Select Region',
  selectAdress: 'Business registration location',
  main1:
    'Fill in the email address to receive settlement files and future platform-related activities. Please do not fill in if you do not want to receive such information',
  eCourierBranch: 'eCourier pick branch',
  save: 'Save',
  main2: 'Apply for store expansion to New countries',
  main3: 'Sorry, there is currently no expandable country site to choose from',
  main4: 'Submit Application',
  main5: 'Application record and status',
  applyLog: 'Application log',
  storeStatus: 'Store Status',
  radio1: 'Open',
  radio2: 'In vacation',
  main6: 'You only set the store in vacation mode for the selected country site.',
  setting: 'Store Shipping Settings',
  English: 'English',
  contactPerson: 'Name',
  tel: 'Number',
  province: 'Province',
  address: 'Address',
  Chinese: 'Chinese',
  transitWarehouseSelection: 'Select Transit Warehouse',
  generalCargo: 'General Products',
  recipient: 'Recipient',
  select1: 'Special cargo',
  select2: 'Electricity, Magnetism, Powder, Compressing agent',
  expandRegionId: 'ExpandRegion ID',
  applyFailed: 'Application Failed',
  applySuccess: 'Successful Application',
  statusList1: 'Pending Audit',
  statusList2: 'Audited',
  statusList3: 'Rejected',
  errorTips1: 'The email fill length cannot exceed 50 characters',
  errorTips2: 'Email format is incorrect',
  errorTips3: 'Please select country site',
  successTips1: 'Submitted successfully',
  errorTips4: 'Please fill in the relevant address information in English',
  errorTips5: 'Please fill in the relevant address information in Chinese',
  errorTips6: 'Please check the country site to be expanded',
  errorTipsArea: 'Please select the last level of the city.',
  emptyEmail: 'E-mail can not be empty',
  expandPaymentNewMarkets: 'Expand payment protocol alerts for new markets',
  youPreparingSubmitAgreement: 'You are preparing to submit an application for expanding your store into a new market. In order to continue, you need to read and agree to the corresponding payment agreement in the relevant country.',
  iHaveReadAndAgreeMoveOn: 'I have read and agree. Move on',
  readAndAgreeThePaymentAgreement: 'Please read and agree to the payment agreement',
  imageRequirements: 'Image requirements: the width and height are equal and the size is within 1 Mb.',
  storeLevelDeliveryFee: 'Store-level Delivery Fee',
  fillEmailAndPhone: 'Fill in the email、phone number and What\'s App Number to receive system notifications or any important files',
  selectCountry: 'Select Country',
  phoneNumber: 'Phone number',
  storeNameSupportLetter: 'Store name support letter, digit and space only',
  inputEmail: 'Please input email',

  source: 'Country code',
  confirm: 'Confirm',
  cancel: 'Cancel',
  revision: 'Revise',
  settingLabel: 'Settings',
  enterCode: 'Enter verification code',
  enterEmail: 'Enter email address',
  enterWA: 'Enter WhatsApp number',
  enterPhone: 'Enter phone number',
  setEmail: 'Set email to receive notifications',
  setWhatsapp: 'Set WhatsApp number to receive notifications',
  setPhoneTips: 'Set phone number to receive notifications',
  emailError: 'Invalid email format',
  phoneError: 'Invalid phone number format',
  whatsappError: 'Invalid WhatsApp number format',
  sendOk: 'Code sent',
  pleaseEnterCode: 'Please get the verification code and enter it first',
  add: 'Add',
  currentPhone: 'Current Tel.: ',
  currentEmail: 'Current What\'s App Number: ',
  currentWA: 'Current email: ',
  pleaseEnter: 'Please enter',
  pleaseSelect: 'Please select'
}
